import produce from "immer";
import ICompanyInfoReducer from "models/ICompanyInfoReducer";
import { actionTypes } from "./actions";

const initialState: ICompanyInfoReducer = {
  isLoading: false,
  isLoaded: false,
  companyDetail: {},
  error: null,
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, (draftState) => {
    switch (action.type) {
      case actionTypes.GET_CUSTOMER_COMPANY_INFORMATION_SUCCESS:
        draftState.companyDetail = action.payload[0];
        draftState.isLoading = false;
        draftState.isLoaded = true;
        break;
      case actionTypes.GET_CUSTOMER_COMPANY_INFORMATION_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
